import React, {useEffect, useState} from 'react';
//import { FaPlus, FaMinus } from 'react-icons/fa';
import PropTypes from "prop-types";
import './style.css';
import {creteJobTypeMethod} from '../../../service/ApiServices';
import Swal from 'sweetalert2';
import {Spin, Switch} from 'antd';
import {

    getAllJobTypeMethod,

} from "../../../service/ApiServices";
import Select from 'react-select';
import {getAllBodyTypeMethod} from '../../../service/styleService';


const CreateJobTypeModal = ({handleCancel, handleJobTypeAdding, selectedJobType}) => {
    const [jobTypeName, setJobTypeName] = useState('');
    const [loading, setLoading] = useState(false);
    const [price, setPrice] = useState('');
    const [selectedStyle, setSelectedStyle] = useState([]);
    const [serviceOptions, setServiceOptions] = useState([]);
    const [bulkCheck, setBulkCheck] = useState(0);
    const [jobTypeOptions, setJobTypeOptions] = useState([]);
    const [bundleItems, setBundleItems] = useState([]);


    const isEditMode = !!selectedJobType;
    const handleInputChange = async (selectedOption) => {
        setSelectedStyle(selectedOption ? selectedOption : []);
        console.log(selectedOption);
    };

    const handleChangeSelect =  (selectedOption) => {
        console.log("selectedOption",selectedOption)
       setBundleItems(selectedOption.map(item => item.value))

    };


    useEffect(() => {
        const initialCalls = async () => {
            const data2 = await getAllJobTypeMethod({
                search: "",
                setLoading: setLoading,
            });
            setJobTypeOptions(data2);
        };
        initialCalls();
    }, []);


    const handleSave = () => {
        if (jobTypeName === '') {
            showWarning("Please enter Job Type Name");
            return;
        }
        if (price === '' || parseFloat(price) === 0 || parseFloat(price) < 0) {
            showWarning("Please enter valid price");
            return;
        }

        if (bulkCheck === 0) {

            creteJobTypeMethod({
                price: price,
                type: jobTypeName,
                styles: selectedStyle.map(item => item.value),
                handleCancel,
                handleReset,
                showSuccess,
                handleJobTypeAdding,
                typeId: selectedJobType?.value,
                setLoading, isBulk: bulkCheck,

            });
        } else {
            creteJobTypeMethod({
                price: price,
                type: jobTypeName,
                handleCancel,
                handleReset,
                showSuccess,
                handleJobTypeAdding,
                typeId: selectedJobType?.value,
                setLoading,
                isBulk: bulkCheck,
                bundleItems: bundleItems

            });
        }
    };

    const handleReset = () => {
        setJobTypeName('');
        setPrice('');
        setSelectedStyle([]);
        setBundleItems([]);
    };
    const editClose = () => {
        setJobTypeName(selectedJobType.label);
        console.log("JOB", selectedJobType)
        //setSelectedStyle(selectedJobType.styles.map(style => ({ value: style._id, label: style.styleName })));
        console.log(selectedJobType.styles)
        setSelectedStyle(selectedJobType.styles.map(style => ({
            value: style._id,
            label: style.styleName
        })))
        setPrice(selectedJobType.price);
    }

    const showSuccess = () => {
        return Swal.fire({
            title: "Good job!",
            text: "You Successfully Saved Job Type!",
            icon: "success"
        });
    };

    const showWarning = (str) => {
        return Swal.fire({
            title: "Error",
            text: str,
            icon: "error",
        });
    };

    useEffect(() => {
        if (!selectedJobType) return;

        // Populate common fields for both simple services and bundles.
        setJobTypeName(selectedJobType.label);
        setPrice(selectedJobType.price);
        setBulkCheck(selectedJobType.isBulk);

        if (selectedJobType.isBulk === 1) {
            // Bundle: load its component items. bundleItems come back as
            // populated job-type docs, so reduce them to their ids.
            setBundleItems(
                (selectedJobType.bundleItems || []).map(
                    (item) => item._id || item.value || item
                )
            );
        } else {
            setSelectedStyle(
                (selectedJobType.styles || []).map((style) => ({
                    value: style._id,
                    label: style.styleName
                }))
            );
        }
    }, [selectedJobType]);

    useEffect(() => {
        const fetchStyles = async () => {
            try {
                const response = await getAllBodyTypeMethod({search: '', setLoading});
                console.log('API Response:', response);
                const options = response.map(item => ({
                    value: item._id,
                    label: item.styleName
                }));
                setServiceOptions(options);
            } catch (error) {
                console.error("Error in fetching Service Names", error);
                showWarning('Failed to fetch job types');
            } finally {
                setLoading(false);
            }
        };

        fetchStyles();
    }, [setLoading]);

    const onChange = (checked) => {
        if (bulkCheck == 0) {
            console.log(jobTypeOptions)
            console.log(`switch to ${checked}`, setBulkCheck(1));

        } else {
            console.log(`switch to ${checked}`, setBulkCheck(0));

        }
    };


    return (
        <div className="modal-content">
            <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                    <h4>{selectedJobType ? "Edit Service" : "Create Service"}</h4>
                    <p className="mb-0">Fill in the required fields to create a</p>
                </div>
            </div>
            <div className="modal-body custom-modal-body">
                <form>
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="input-blocks">
                                <label htmlFor="jobTypeName">Service Name</label>
                                <input
                                    type="text"
                                    id="jobTypeName"
                                    className="form-control"
                                    aria-label="Job Type Name"
                                    value={jobTypeName}
                                    onChange={(event) => setJobTypeName(event.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="input-blocks">
                                <label>Bundle</label>
                                <Switch checked={bulkCheck === 1} onChange={onChange}/>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="input-blocks">
                                <label htmlFor="price">Price (Rs.)</label>
                                <input
                                    type="number"
                                    id="price"
                                    className="form-control"
                                    aria-label="Price"
                                    value={price}
                                    onChange={(event) => setPrice(event.target.value)}
                                />
                            </div>
                        </div>


                    </div>
                    {bulkCheck === 0 ?
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="input-blocks">
                                    <label>Styles</label>
                                    <Select
                                        className="select"
                                        options={serviceOptions}
                                        placeholder="Select a style"
                                        value={selectedStyle}
                                        onChange={handleInputChange}
                                        isMulti={true}
                                    >
                                    </Select>
                                </div>
                            </div>
                        </div>

                        : <>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="input-blocks">
                                        <label>Single Item</label>

                                        <Select
                                            options={jobTypeOptions}
                                            placeholder="Choose Item"
                                            value={jobTypeOptions.filter((opt) =>
                                                bundleItems.includes(opt.value)
                                            )}
                                            onChange={handleChangeSelect}
                                            required
                                            isMulti={true}

                                        />

                                    </div>
                                </div>
                            </div>

                        </>


                    }
                </form>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}>
                    <button
                        type="button"
                        className="btn btn-cancel"
                        onClick={() => {
                            handleCancel();
                            if (!isEditMode) handleReset();
                            if (isEditMode) editClose();
                        }}
                    >
                        Close
                    </button>
                    <div>
                        <button
                            type="button"
                            className="btn btn-reset me-2"
                            onClick={handleReset}
                        >
                            Reset
                        </button>
                        <button className="btn btn-submit" onClick={handleSave}>
                            {loading ? <Spin size='small'/> : "Save"}
                        </button>
                    </div>

                </div>

            </div>
        </div>
    );
};

CreateJobTypeModal.propTypes = {
    handleCancel: PropTypes.func.isRequired,
    handleJobTypeAdding: PropTypes.func.isRequired,
    selectedJobType: PropTypes.object.isRequired
};

export default CreateJobTypeModal;
